import { stringOrNull, TMaybe } from "../helpers/TsHelpers";
import { TFolder } from "./folder-model";

export type TFile = {
  id: string;
  type: "FILE";
  folderId: string;
  name: TMaybe<string>;
  author: TMaybe<string>;
  sizeBytes: TMaybe<number>;
  authorFill: TMaybe<string>;
  dateCreated: TMaybe<string>;
  dateModified: TMaybe<string>;
  authorStroke: TMaybe<string>;
  fileExtension: TMaybe<string>;
};

// eslint-disable-next-line -- unless we want to generate types from the schema
export const mapFileFromGQL = (raw: any) => {
  if (!raw) {
    return null;
  }

  if (raw.id && typeof raw.id === "string") {
    const author = stringOrNull(raw.owner ? [raw.owner.firstName, raw.owner.lastName].filter(Boolean).join(" ") : "");

    const file: TFile = {
      author,
      id: raw.id,
      type: "FILE",
      folderId: raw.folderId,
      sizeBytes: +raw.fileSizeBytes || null,
      dateCreated: stringOrNull(raw.dateCreated),
      dateModified: stringOrNull(raw.lastUpdatedUtc),
      fileExtension: stringOrNull(raw.fileExtension),
      authorFill: stringOrNull(raw.owner?.colorFill),
      authorStroke: stringOrNull(raw.owner?.colorStroke),
      name: stringOrNull(raw.fullName) || stringOrNull(raw.name),
    };

    return file;
  }

  return null;
};

export const getSizeMany = (selected: TFile[]) =>
  (selected || []).reduce((acc, v) => (acc = acc + (v.sizeBytes || 0)), 0);

export const KB_SIZE = 1024;
export const MB_SIZE = KB_SIZE * 1024;
export const GB_SIZE = MB_SIZE * 1024;

export const getPrettySizeFromBytes = (sizeInBytes: number) => {
  if (sizeInBytes < 1) {
    return "0 B";
  } else if (sizeInBytes < KB_SIZE) {
    return `${sizeInBytes} B`;
  } else if (sizeInBytes < MB_SIZE) {
    return `${(sizeInBytes / KB_SIZE).toFixed(0)} KB`;
  } else if (sizeInBytes < GB_SIZE) {
    return `${(sizeInBytes / MB_SIZE).toFixed(2)} MB`;
  } else {
    return `${(sizeInBytes / GB_SIZE).toFixed(2)} GB`;
  }
};

export const getPrettySize = (item: TFile | TFolder) => {
  if (item.type === "FILE") {
    const sizeInBytes = item.sizeBytes ?? 0;
    return getPrettySizeFromBytes(sizeInBytes);
  }

  return "";
};
